// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__yojdH","default":"Button_default__1Qry4","invert":"Button_invert__5C3CW"};